/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

// PLACEHOLDER REPLACE ENTIRE FILE AS PART OF TP-4914
// - likely want to more formally factory this
// - creating a service that returns pseudo-class objects is very... old school javascript

import { Injectable } from '@angular/core';
import { TicketFields, TicketRenderTypes } from '@touchplan/common';
import { GroupedTicket } from '@touchplan/ticket';
import { BehaviorSubject, of, Subject } from 'rxjs';
import { filter, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { FancySimpleTicketGrouper } from 'src/app/app-data/models/FancyGrouper';
import { TicketList } from 'src/app/common/fancy-firebase-ticket/lists/TicketList';
import { makeTicketEditObservable } from 'src/app/common/fancy-firebase-ticket/utils/make-ticket-edit-observer';
import {
	subjectSubscribeWithoutComplete,
	ticketListRace,
	ticketListRaceModern,
} from 'src/app/plain-javascript/services/rxjs-internal-extensions';
import { PlanState } from 'src/app/services/plan-state.service';

//TODO: this was duplicated from docked-ticket-container, do better
interface ILiveUpdateEvent {
	ticket: GroupedTicket;
	updateData: TicketFields;
}

//another temp thing to make plan.component's new found type checking shutup
export interface ITempDock {
	ticket$: BehaviorSubject<GroupedTicket>;
	[key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class PlanDockedTicketBinding {
	//TODO: this is currently pointless and is mostly jut to make all the copied code shutup
	//determining the exact lifecycle and clean up tbd
	public shutdownSubject = new Subject<void>();
	private ticketList!: TicketList;

	constructor(private planState: PlanState) {}

	public startMonitoring() {
		//start temp docked ticket testing
		const ticketSub$ = new BehaviorSubject<GroupedTicket>(null);

		// BEGIN PLACEHOLDER REPLACE AS PART OF TP-7102
		// - mostly just "think a bit more"
		const targetListOb$ = ticketListRaceModern(
			(item) => item,
			[this.planState.tickets.editTicket$, this.planState.floatingTickets.editTicket$],
			[this.planState.tickets, this.planState.floatingTickets]
		).pipe(
			//the side effect might legit be the safest way to do this
			// super timing dependent. Will need to think more...
			tap((list) => (this.ticketList = list)),
			switchMap((list) => list.safeRawEvent$())
		);
		// END PLACEHOLDER REPLACE AS PART OF TP-7102

		const ticketGrouper = new FancySimpleTicketGrouper();
		ticketGrouper.start(
			// makeTicketEditObservable(this.planState.tickets.rawEvent$) //works for normal edit
			makeTicketEditObservable(targetListOb$)
		);

		ticketGrouper.grouped$
			.pipe(
				takeUntil(this.shutdownSubject)
				// tap((g) => console.log(g))
			)
			.subscribe(subjectSubscribeWithoutComplete(ticketSub$));

		const role$ = this.planState.rolesApi.data.list$.pipe(
			map((roleMap) => Array.from(roleMap.values())),
			takeUntil(this.shutdownSubject)
		);
		const location$ = this.planState.locationsApi.data.list$.pipe(
			map((locationMap) => Array.from(locationMap.values())),
			takeUntil(this.shutdownSubject)
		);
		const projectMember$ = this.planState.projectMembersApi.data.list$.pipe(
			map((projectMembersMap) => Array.from(projectMembersMap.values())),
			takeUntil(this.shutdownSubject)
		);

		const prioritie$ = this.planState.priorities.list$.pipe(
			map((priorityMap) => Array.from(priorityMap.values()).sort((a, b) => a.sortOrder - b.sortOrder)),
			takeUntil(this.shutdownSubject)
		);

		const variance$ = this.planState.variances.list$.pipe(
			map((varianceMap) => Array.from(varianceMap.values())),
			takeUntil(this.shutdownSubject)
		);

		const tempDock = {
			destroy: () => this.shutdownSubject.next(),
			ticket$: ticketSub$,
			//TODO - workaround for grouped ticket emitting something silly on "remove final item from list" event
			//This prevents other components from having to deal with that
			dockedTicketSafeTicket$: ticketSub$.pipe(filter((t) => t?.srcList?.size > 0)),
			role$,
			location$,
			projectMember$,
			prioritie$,
			variance$,
			allowList: of([]),
			ticketDataChanged: (t: ILiveUpdateEvent) => {
				console.log('ticketDataChanged', t);
				const group = ticketSub$.getValue();
				this.planState.actions.updateTicketLiveData(t.ticket.$id, t.updateData, this.ticketList);
			},
			persistTicketData: (t) => {
				console.log('persistTicketData', t);
				this.planState.actions.persistTicketData(ticketSub$.getValue().srcList, this.ticketList);
				// this.planState.actions.changeTicketViewToDefault(ticketSub$.getValue().srcList);
			},
			//TODO: all of these have a groupedTicket as an arg, should really add those
			//Do note, this method is not "change to db view", but instead "revert data of edit view to database data"
			revertToDatabase: (t: GroupedTicket) => {
				console.log('revertToDatabase', t);
				this.planState.actions.changeTicketViewDataToDefault(t.srcList, this.ticketList);
			},
			shouldClose: (t) => {
				console.log('shouldClose', t);
				this.planState.actions.changeTicketViewToDefault(ticketSub$.getValue().srcList, this.ticketList);
			},
		};
		return tempDock;
	}
}
